module.exports = __webpack_public_path__ + "static/media/Tribute-Wixom-ByLaws.8aa47190.pdf";